export default __webpack_public_path__ + "static/media/1107.0b212c90.png";